import { Box } from "ui/base/Box";

export const GridBg = () => (
  <Box className="absolute inset-0 h-full w-full bg-white bg-[radial-gradient(#aaaaaa_1px,transparent_1px)] bg-size-[16px_16px] -z-10"></Box>
);
